import styled from 'styled-components/macro'

import { Overlay, Thread } from 'styles/misc'
import { Section as SectionBase } from 'components/misc'
import { TextContainer } from 'components/container'
import { mq } from 'styles/mq'

export const Section = styled(SectionBase)`
  position: relative;
  padding-top: 5%;

  &::before {
    ${Thread}
    display: block;
    width: 100%;
    aspect-ratio: 1440 / 350;
    transform: translateY(-100%);
    mask-size: 100% auto;
    mask-image: url("data:image/svg+xml,%3Csvg width='1440' height='635' viewBox='0 0 1440 635' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath d='M-450.817 1C-463.5 35.3051 -476.325 70.3743 -477.286 106.928C-478.246 143.481 -465.247 182.447 -435.362 203.534C-395.829 231.443 -341.189 220.365 -296.406 202.039C-160.277 146.33 -44.9843 33.8862 101.175 17.3503C124.991 14.6544 152.038 15.8004 168.694 33.0239C193.613 58.7828 179.816 101.776 161.032 132.294C142.248 162.811 117.744 212.79 128.79 231.236C146.635 261.033 198.546 168.029 233.004 178.387C245.731 182.218 238.385 202.945 230.81 218.324C223.235 233.692 217.079 255.663 216.424 272.789C215.551 295.786 235.46 315.422 257.519 321.992C279.577 328.563 303.219 325.103 325.932 321.338C536.718 286.443 744.23 230.909 956.762 209.09C1169.29 187.271 1667.54 233.637 1917 634.493' stroke='black' stroke-width='1.5' vector-effect='non-scaling-stroke' stroke-miterlimit='10'/%3E%3C/svg%3E");
  }

  ${TextContainer} {
    position: relative;
  }
`

export const Graphics = styled.div`
  position: absolute;
  right: 0;
  transform: translateX(75%);
  width: 51.3rem;
  height: 68.7rem;
  pointer-events: none;
  z-index: -1;

  ${mq.smallOnly} {
    display: none;
  }

  > div {
    ${Overlay}
    opacity: 0.75;
    mask: url("data:image/svg+xml,%3Csvg width='513' height='687' viewBox='0 0 513 687' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M513 256.668L256.5 0L0 256.668L172.844 429.626L0 602.584L84.3608 687L168.545 602.76L168.369 602.584L256.505 514.39L344.655 602.598L344.479 602.775L428.649 687L513.01 602.584L340.166 429.626L513.01 256.668H513ZM344.636 256.668L256.5 344.862L168.364 256.668L256.5 168.475L344.636 256.668Z'/%3E%3C/svg%3E")
      center center / contain no-repeat;
    background-color: var(--theme-color);
  }
`
